module.exports = __webpack_public_path__ + "img/35_6.30d3e0c5.png";